import UserInfo from './UserInfo'
import logo from '../assets/logo.svg'

const SignalBars = ({ quality = 4 }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <rect x="2" y="16" width="4" height="6" rx="1" opacity={quality >= 1 ? 1 : 0.3} />
    <rect x="8" y="11" width="4" height="11" rx="1" opacity={quality >= 2 ? 1 : 0.3} />
    <rect x="14" y="6" width="4" height="16" rx="1" opacity={quality >= 3 ? 1 : 0.3} />
    <rect x="20" y="2" width="4" height="20" rx="1" opacity={quality >= 4 ? 1 : 0.3} />
  </svg>
)

function getStatusText(connectionStatus) {
  switch (connectionStatus) {
    case 'initializing': return 'Setting up'
    case 'waiting': return 'Waiting for someone to join'
    case 'connecting': return 'Connecting'
    case 'connected': return 'Connected'
    case 'reconnecting': return 'Reconnecting...'
    case 'ended': return 'Call ended'
    case 'error': return 'Connection error'
    default: return connectionStatus
  }
}

function StatusBar({ connectionStatus, callQuality }) {
  return (
    <div className="status-bar">
      <img src={logo} alt="Call Mom" className="room-logo" />
      {connectionStatus === 'connected' ? (
        <span className="signal-indicator">
          <SignalBars quality={callQuality} />
          <span className="signal-indicator-content">Connected</span>
        </span>
      ) : (
        <span className={`status ${connectionStatus}`}>{getStatusText(connectionStatus)}</span>
      )}
      <UserInfo showLogout={false} />
    </div>
  )
}

export { getStatusText }
export default StatusBar
